<ng-container *ngIf="order$ | async as order">
  <ng-container *ngIf="order.code">
    <div class="cx-nav row reorder-gonvarri">
      <div class="col-xs-12 col-md-10 col-lg-8">
        <button
          #element
          class="btn btn-primary"
          (click)="onReorderClick(order)"
        >
          {{ 'reorder.button' | cxTranslate }}
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>
